import React, { useState } from 'react';
import './../../entrydoor.css';
import { convertToMetric } from '../conversions';
import { parseMeasurements } from '../conversions';

const OverrideExtension = ({ value, onChange, label = 'Override Extension:' }) => {
    const [selectedOverrideExtension, setSelectedOverrideExtension] = useState(value || "");
     const [OverrideExtensionError, setOverrideExtensionError] = useState("");

    const handleOverrideExtensionChange = (e) => {
        //setSelectedOverrideExtension(e.target.value);
        validateOverrideExtension(e.target.value);
        onChange(e.target.value);
    };
    const validateOverrideExtension = (value) => {
        const numericValue = value; //parseMeasurements(value); //value.replace(/\D/g, ""); // Allow only numbers
        setSelectedOverrideExtension(numericValue);

        const element = document.getElementById('FrameExtension');
        if (element !== "None") {
            const FrameExtensionValue = convertToMetric(element.value);
            const numericValueMetric = convertToMetric(numericValue);
            //alert(FrameExtensionValue + " "  + numericValueMetric)
               
            if (numericValue && (numericValueMetric > FrameExtensionValue)) {
                setOverrideExtensionError(`Everride Extension must be less or equal to${element.value}"`);
            } else {
                setOverrideExtensionError("");
            }
        }        
    };

    return (
        <div className="a-container">
            <label style={{ display: "none" }} htmlFor="OverrideExtension">{label}</label>
            <input style={{ display: "none" }}
                id="OverrideExtension"
                value={selectedOverrideExtension}
                onChange={handleOverrideExtensionChange}
            >
            </input>
            {OverrideExtensionError && <p className="error">{OverrideExtensionError}</p>}
        </div>
    );
};

export default OverrideExtension;
